import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Voice } from '../data/testimonials';
type TestimonialsProps = {
  voices: Voice[];
  title?: string;
  background?: 'white' | 'panel';
};

/**
 * Frases reales de facilitadores en fuentes públicas, con fuente. No se
 * presentan como reseñas del producto. Con el array vacío no se muestra.
 */
export function Testimonials({
  voices,
  title = 'Sound familiar?',
  background = 'white'
}: TestimonialsProps) {
  if (voices.length === 0) return null;
  const bg = background === 'white' ? 'bg-white' : 'bg-paper-dark';
  return <section aria-label={title} className={`w-full text-pine ${bg}`} data-id="element-262" data-mp="2x0jnulfopxdx">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-263" data-mp="2x2w32qu25tna">
        <div className="text-center" data-id="element-264" data-mp="2s2rwbsiycda9">
          <p className="eyebrow text-ember-deep" data-id="element-265" data-mp="2s3tba8339jx9">Facilitator to facilitator</p>
          <h2 className="trail-underline mt-3 font-display text-[30px] leading-tight text-pine sm:text-5xl" data-id="element-266" data-mp="v8wuid8blqea">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-pine-soft" data-id="element-267" data-mp="h67zg4hknoad">
            Real words from facilitators in public sources. This is exactly
            the week Vivencia Ready was built for.
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-268" data-mp="78tt4xpd4fvs">
          {voices.map(item => <figure key={item.quote} className="trail-card rounded-2xl border border-paper-dark bg-paper p-6" data-id="element-269" data-mp="c7myu3yer2le">
              <QuoteIcon className="h-7 w-7 text-ember" aria-hidden="true" data-id="element-270" data-mp="14vj0ln2u3kp1" />
              <blockquote className="field-note mt-2 text-[28px] leading-[1.1] text-pine" data-id="element-271" data-mp="14xlp22oc95rn">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 text-xs text-pine-soft" data-id="element-272" data-mp="v4xuzfoqtfwm">
                <span className="block text-[13px] font-bold text-pine" data-id="element-273" data-mp="1ivaelntcp131">
                  {item.author}
                </span>
                {item.source}
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 text-center text-[11px] text-pine-muted" data-id="element-274" data-mp="1xi92j8t01dd0">
          Quoted as written from public sources. Not reviews of this product.
        </p>
      </div>
    </section>;
}